import { gql } from 'apollo-client-ppc';

export const fetchAvailableInvoiceGroupsForOrderReview = gql`
  query fetchAvailableInvoiceGroupsForOrderReview($id: ID!) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availableInvoiceGroups {
        nodes {
          id
          shipToPriceEligibility
          defaultPaymentMethod {
            id
            type
            paymentIssue
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
                cardHolderName
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
        }
      }
    }
  }
`;
